import { PropTypes } from "prop-types";
import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { Card, CardBody, CardTitle, Row } from "reactstrap";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import LineColumnArea from "./common/TestChart";
import classNames from "classnames";
import WelcomeComp from "./common/WelcomeComp";
import MonthlyEarning from "./common/MonthlyEarning";

const DashboardTest = ({ clientId, getTransactionsChart, data, contractor }) => {
  const [reports, setReports] = React.useState([
    { title: "Invoices", iconClass: "bx-copy-alt", description: "1,235" },
    {
      title: "Revenue",
      iconClass: "bx-archive-in",
      description: "$35, 723",
    },
    {
      title: "Balance",
      iconClass: "bx-purchase-tag-alt",
      description: "$16.2",
    },
    // {
    //   icon: "bx bx-archive-in",
    //   title: "Revenue",
    //   value: 15,
    //   badgeValue: "15%",
    //   color: "success",
    //   desc: "From previous period",
    // },
    // {
    //   icon: "bx bx-archive-in",
    //   title: "Revenue",
    //   value: 15,
    //   badgeValue: "15%",
    //   color: "success",
    //   desc: "From previous period",
    // },
    // {
    //   icon: "bx bx-purchase-tag-alt",
    //   title: "Average Price",
    //   value: 15,
    //   badgeValue: "15%",
    //   color: "success",
    //   desc: "From previous period",
    // },
  ]);
  React.useEffect(() => {
    let rep = [...reports];
    rep[2].description = contractor?.balance || '0.00';
    setReports(rep)
  }, [contractor]);

  return (
    <React.Fragment>
      <Row>
        <Col xl="4">
          <WelcomeComp />
          <MonthlyEarning
            // data={this.state.ranges}
            // date={this.state.date_range}
          />
        </Col>
        <Col xl="8">
          <Row>
            {/* Reports Render */}
            {reports.map((report, key) => (
              <Col md="4" key={"_col_" + key}>
                <Card className="mini-stats-wid">
                  <CardBody>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <p className="text-muted fw-medium">{report.title}</p>
                        <h4 className="mb-0">{report.description}</h4>
                      </div>
                      <div className="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                        <span className="avatar-title">
                          <i
                            className={
                              "bx " + report.iconClass + " font-size-24"
                            }
                          />
                        </span>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          <Card>
            <CardBody>
              <div className="d-sm-flex flex-wrap">
                <CardTitle className="card-title mb-4 h4">
                  Services provided
                </CardTitle>
                <div className="ms-auto d-none">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <Link
                        to="#"
                        className={classNames(
                          // { active: this.state.periodType === "weekly" },
                          "nav-link"
                        )}
                        onClick={() => {
                          // this.setState({
                          //   ...this.state,
                          //   periodType: "weekly",
                          // });
                          // this.props.onGetChartsData("weekly");
                        }}
                        id="one_month"
                      >
                        Week
                      </Link>{" "}
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#"
                        className={classNames(
                          // { active: this.state.periodType === "monthly" },
                          "nav-link"
                        )}
                        onClick={() => {
                          // this.setState({
                          //   ...this.state,
                          //   periodType: "monthly",
                          // });
                          // this.props.onGetChartsData("monthly");
                        }}
                        id="one_month"
                      >
                        Month
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#"
                        className={classNames(
                          // {
                          //   active: this.state.periodType === "two-month",
                          // },
                          "nav-link"
                        )}
                        // onClick={() => {
                        //   this.setState({
                        //     ...this.state,
                        //     periodType: "two-month",
                        //   });
                        //   this.props.onGetChartsData("two-month");
                        // }}
                        id="one_month"
                      >
                        Two Month
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="clearfix" />
              {/* <StackedColumnChart
                chartSeries={this.state.chartSeries}
                data={this.state.ranges}
                date={this.state.date_range}
              /> */}
              <LineColumnArea data={data} />
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* <Card> */}
      {/* <CardBody>
          <Row>
            <Col
              lg="12"
              className="align-self-center d-flex text-center justify-content-center align-items-center vertical-align-middle"
            >
              <Row>
                <Col xs="4">
                  <div style={{ width: 200 }}>
                    <p className="text-muted text-truncate mb-2">
                      Total Projects
                    </p>
                    <h5 className="mb-0">{500}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div style={{ width: 200 }}>
                    <p className="text-muted text-truncate mb-2">Projects</p>
                    <h5 className="mb-0">{400}</h5>
                  </div>
                </Col>
                <Col xs="4">
                  <div style={{ width: 200 }}>
                    <p className="text-muted text-truncate mb-2">Clients</p>
                    <h5 className="mb-0">{300}</h5>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card> */}
      {/* <Row>
        {reports.map((report, key) => (
          <Col sm="4" key={key}>
            <Card>
              <CardBody>
                <div className="d-flex align-items-center mb-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-primary bg-soft text-primary font-size-18">
                      <i className={report.icon} />
                    </span>
                  </div>
                  <h5 className="font-size-14 mb-0">{report.title}</h5>
                </div>
                <div className="text-muted mt-4">
                  <h4>
                    {report.value}{" "}
                    <i className="mdi mdi-chevron-up ms-1 text-success" />
                  </h4>
                  <div className="d-flex">
                    <span
                      className={
                        "badge badge-soft-" + report.color + " font-size-12"
                      }
                    >
                      {" "}
                      {report.badgeValue}{" "}
                    </span>{" "}
                    <span className="ms-2 text-truncate">{report.desc}</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row> */}
      <Card style={{ height: 372 }} className="d-none">
        <CardBody>
          <LineColumnArea data={data} />
        </CardBody>
      </Card>
      <Row className="mt-3"></Row>
    </React.Fragment>
  );
};

DashboardTest.propTypes = {
  userId: PropTypes.string,
  history: PropTypes.any,
  permissions: PropTypes.any,
  clientId: PropTypes.any,
  getTransactionsChart: PropTypes.func,
  data: PropTypes.any,
  contractor: PropTypes.any,
};

export default withRouter(DashboardTest);
